import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-bcrm-data',
  templateUrl: './reset-bcrm-data.component.html',
  styleUrls: ['./reset-bcrm-data.component.scss']
})
export class ResetBcrmDataComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
